import { render, staticRenderFns } from "./DaftarBaukNonPo.vue?vue&type=template&id=74fee3c6&scoped=true"
import script from "./DaftarBaukNonPo.vue?vue&type=script&lang=js"
export * from "./DaftarBaukNonPo.vue?vue&type=script&lang=js"
import style0 from "./DaftarBaukNonPo.vue?vue&type=style&index=0&id=74fee3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fee3c6",
  null
  
)

export default component.exports